<template>
  <div class="wb-logo-wrap" :style="cssStyle">
    <div class="wb-logo" :style="{ width: w, height: h }">
      <img :src="logoPic" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'wb-logo',

    props: {
      w: {
        type: String,
        default: undefined
      },
      h: {
        type: String,
        default: undefined
      },
      cssStyle: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      logoPic() {
        if (this.$i18n.locale === 'zh_HK') {
          return this.$appTheme.getThemeAsset('logoHk')
        } else {
          return this.$appTheme.getThemeAsset('logo')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/theme/themes.scss';

  .wb-logo {
    width: $loginLogoWidth;
    height: 36px;

    > img {
      width: 100%;
      height: 100%;
    }
  }
</style>
